export const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR';

export const GET_HIERARCHICAL_COMPANIES_REQUEST = 'GET_HIERARCHICAL_COMPANIES_REQUEST';
export const GET_HIERARCHICAL_COMPANIES_SUCCESS = 'GET_HIERARCHICAL_COMPANIES_SUCCESS';
export const GET_HIERARCHICAL_COMPANIES_ERROR = 'GET_HIERARCHICAL_COMPANIES_ERROR';

export const ADD_COMPANY_REQUEST = 'ADD_COMPANY_REQUEST';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_ERROR = 'ADD_COMPANY_ERROR';


export const GET_COMPANIES_WITHOUT_MANAGER_REQUEST = 'GET_COMPANIES_WITHOUT_MANAGER_REQUEST';
export const GET_COMPANIES_WITHOUT_MANAGER_SUCCESS = 'GET_COMPANIES_WITHOUT_MANAGER_SUCCESS';
export const GET_COMPANIES_WITHOUT_MANAGER_ERROR = 'GET_COMPANIES_WITHOUT_MANAGER_ERROR';

export const GET_COMPANIES_WITHOUT_SURVEY_REQUEST = 'GET_COMPANIES_WITHOUT_SURVEY_REQUEST';
export const GET_COMPANIES_WITHOUT_SURVEY_SUCCESS = 'GET_COMPANIES_WITHOUT_SURVEY_SUCCESS';
export const GET_COMPANIES_WITHOUT_SURVEY_ERROR = 'GET_COMPANIES_WITHOUT_SURVEY_ERROR';

export const GET_PERIMETER_STRUCTURE_REQUEST = 'GET_PERIMETER_STRUCTURE_REQUEST';
export const GET_PERIMETER_STRUCTURE_SUCCESS = 'GET_PERIMETER_STRUCTURE_SUCCESS';
export const GET_PERIMETER_STRUCTURE_ERROR = 'GET_PERIMETER_STRUCTURE_ERROR';
